(function () {
  const cartContainer = document.getElementById('ajax-cart');
  if (!cartContainer) return;

  function renderCart(cart) {
    if (!cart || cart.item_count === 0) {
      cartContainer.innerHTML = `
        <div class="cart-items" style="flex: 1;">
          <div style="padding: 12px; text-align: center; color: #888; background: #fafafa; border-radius: 8px;">
            您的購物車目前是空的。
          </div>
        </div>
        <div class="cart-total" style="width: 160px;"></div>
      `;
      return;
    }

    let itemsHtml = `
      <table style="width: 100%; border-collapse: collapse; background: #fff; border-radius: 8px; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.08);">
        <thead>
          <tr style="background: #f8f9fa;">
            <th style="padding: 3px 12px; text-align: left; font-weight: 500; color: #333; border-bottom: 1px solid #eee; font-size: 15px;">已落單</th>
            <th style="padding: 3px 12px; text-align: center; font-weight: 500; color: #333; border-bottom: 1px solid #eee; width: 70px;font-size: 15px;">數量</th>
            <th style="padding: 3px 12px; text-align: center; font-weight: 400; color: #333; border-bottom: 1px solid #eee; width: 80px;font-size: 15px;"></th>
          </tr>
        </thead>
        <tbody>`;

    cart.items.forEach(item => {
      itemsHtml += `
        <tr id="cart-item-${item.variant_id}" style="border-bottom: 1px solid #f0f0f0;">
          <td style="padding: 2px 12px;">
            <a href="${item.url}" style="color: #1a73e8; text-decoration: none; font-weight: 400; font-size: 15px;">${item.title}</a>
          </td>
          <td style="padding: 2px 12px; text-align: center; color: #555; ">${item.quantity}</td>
          <td style="padding: 2px 12px; text-align: center;">
            <form action="/cart/change" method="post" class="cart-remove-form" style="display: inline;">
              <input type="hidden" name="id" value="${item.variant_id}">
              <input type="hidden" name="quantity" value="0">
              <button type="submit" class="remove-button" 
                style="background: #ff4d4f; color: white; border: none; padding: 2px 10px; border-radius: 3px; cursor: pointer; font-size: 12px;">
                移除
              </button>
            </form>
          </td>
        </tr>`;
    });

    itemsHtml += `
        </tbody>
      </table>`;

    cartContainer.innerHTML = `
      <div class="cart-items" style="flex: 1;">
        ${itemsHtml}
      </div>
      <div class="cart-total" style="width: 110px;">
        <div style="background: #fff; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.08); overflow: hidden;">
          <div style="background: #1a73e8; color: white; padding: 4px 8px; font-weight: 500; text-align: center; font-size: 14px;">
            總商品數量
          </div>
          <div style="padding: 3px 8px; text-align: center; font-size: 22px; font-weight: 500; color: #1a73e8;">
            ${cart.item_count}
          </div>
        </div>
      </div>
    `;

    bindRemoveButtons();
  }

  async function refreshCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      renderCart(cart);
    } catch (err) {
      console.error('Refresh cart failed:', err);
    }
  }

  function bindRemoveButtons() {
    document.querySelectorAll('.cart-remove-form').forEach(form => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const formData = new FormData(form);

        try {
          const response = await fetch('/cart/change.js', {
            method: 'POST',
            body: formData
          });

          if (response.ok) {
            const cart = await response.json();
            renderCart(cart);
          }
        } catch (error) {
          console.error('Remove failed:', error);
        }
      });
    });
  }

  // Initial bind
  bindRemoveButtons();

  // Detect Add to Cart
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (form.matches('form[action*="/cart/add"]')) {
      setTimeout(refreshCart, 800);
    }
  });

  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);

    try {
      const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url);
      if (url && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update'))) {
        response.clone().json().then(data => {
          if (data && typeof data.item_count !== 'undefined') {
            renderCart(data);
          } else {
            setTimeout(refreshCart, 300);
          }
        }).catch(() => {
          setTimeout(refreshCart, 300);
        });
      }
    } catch (err) {}

    return response;
  };

  document.addEventListener('cart:updated', refreshCart);
  document.addEventListener('cart:refresh', refreshCart);
  document.addEventListener('theme:cart:change', refreshCart);

})();